// extracted by mini-css-extract-plugin
export default {"link":"StoreBadge-module--link--a3a44","image":"StoreBadge-module--image--8450b"};